// src/apiConfig.js

// If Vercel provides a custom URL, use it. Otherwise, fallback to localhost.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default API_BASE_URL;